module.exports = __webpack_public_path__ + "static/media/icons-ic-incoming-call-status.e41744ed.svg";